import React, { useEffect, useState } from "react"
import { Dialog } from '@headlessui/react'
import { LinkIcon } from '@heroicons/react/solid'
import { useForm } from "react-hook-form"

import { useUser } from "../../providers/UserProvider"

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const ProductName = (props) => {
  const [user, userDispatch] = useUser();

  const { register, handleSubmit, watch, formState: { errors } } = useForm({
    defaultValues: {
      // product: '',
      link: '',
    }
  });

  const onSubmit = data => {
    console.log(data);
    userDispatch({ type: "productRequest/product", payload: { ...data } });
    props.submitAction();
  };

  const [formReady, setFormReady] = useState(false)

  const product = watch('product')

  useEffect(() => {
    setFormReady((product && product.length > 0))
  }, [product])

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mx-auto flex items-center justify-center">
          <span className="inline-flex items-center py-1 px-2 rounded-3 text-body-2 font-bold bg-blue-banner text-blue-bannerTitle font-primary">
            New Feature!
          </span>
        </div>
        <div className="mt-4 text-center">
          <Dialog.Title
            as="h3"
            className="text-md leading-7 font-primary font-bold text-convoy-section-title xl:text-xl"
          >
            Save BIG on your biggest purchases
          </Dialog.Title>
          <div className="mt-3">
            <p className="font-primary text-xxs leading-5 text-grey-footer xl:text-xs">Let us know what major purchases you have coming up—equipment, machinery, devices & more—so we can work on negotiating a discount on your behalf. </p>
          </div>
          <div className="mt-3 text-left">
            <label htmlFor="product" className="block font-primary text-convoy-section-title-smaller text-xxs leading-5">
              Product name
            </label>
            <div className="mt-1">
              <input
                type="text"
                placeholder={"Can be an item type or brand name"}
                {...register("product", { required: true })}
                className="focus:outline-none text-grey-footer placeholder-grey-inputPlaceholderText focus:ring-grey-footer border focus:border-grey-footer block w-full border-grey-inputPreFocusBorder rounded-md font-bold px-3 py-input text-xxs leading-3"
              />
            </div>
          </div>
          <div className="mt-3 text-left">
            <label htmlFor="link" className="block font-primary text-convoy-section-title-smaller text-xxs leading-5">
              Link to product page
            </label>
            <div className="mt-1 relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <LinkIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
              </div>
              <input
                type="text"
                {...register("link")}
                className="focus:outline-none text-grey-footer placeholder-grey-inputPlaceholderText focus:ring-grey-footer border focus:border-grey-footer block w-full border-grey-inputPreFocusBorder rounded-md font-bold px-3 py-input text-xxs leading-3 pl-10"
              />
            </div>
          </div>

          <div className="mt-3">
            <button type="submit" disabled={!formReady} className={"text-xs inline-flex justify-center w-full rounded-100 border border-transparent text-center font-black font-primary text-grey-buttonText focus:outline-none py-4 leading-buttonText hover:bg-blue-buttonHover " + classNames(formReady ? "bg-blue-800" : "bg-grey-inputPreFocusBorder")}>
              Let’s go!
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ProductName;
